import { Component } from '@angular/core';

@Component({
  selector: 'pmd-navbar-brand',
  template: `<ng-content></ng-content>`,
  standalone: false,
})
export class PmdNavbarBrand {}
